// the possible types of things that the library knows to be drag and droppable
export default {
	TABLE_ROW: 'tableRow',
};
